import Image from "next/image";
import type { SupportedLanguage } from "@/lib/shared";
import lang from "./lang.json";

/**
 * Rendered once from `app/[locale]/apply-job/layout.tsx` so the hero image does not
 * remount or refetch on client navigations between wizard steps.
 */
export default function ApplyJobLeftPanel({
  locale,
}: {
  locale: SupportedLanguage;
}) {
  /** مطابق لـ hr-web-main: نصف العرض، ارتفاع الشاشة، يسار LTR / يمين RTL */
  return (
    <div className="fixed top-0 left-0 z-0 hidden h-screen w-1/2 items-center justify-center bg-primary-darken p-10 md:flex rtl:left-auto rtl:right-0">
      <div className="absolute inset-0">
        <Image
          src="/images/applyjob-bg.webp"
          alt={lang["apply-job"][locale]}
          fill
          priority
          className="object-cover"
          sizes="(min-width: 768px) 50vw, 100vw"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
      </div>
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-end pb-20 text-center">
        <div className="mb-10" />
        <h2 className="mb-4 text-3xl font-bold text-white">
          {lang["apply-job"][locale]}
        </h2>
        <p className="text-white text-opacity-90">
          {lang["begin-application"][locale]}
        </p>
      </div>
    </div>
  );
}
